export default __webpack_public_path__ + "static/media/boardroom.6771e3bc.svg";